"use client";

import { motion } from "framer-motion";
import Image from "next/image";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { faq } from "@/data/faq-content";

import HeaderSection from "../header-section";

const FAQSection = () => {
  return (
    <section className="relative py-20" id="faq">
      <Image
        src="/paws.png"
        width={500}
        height={200}
        alt="paws"
        className="absolute top-0 left-0 hidden h-auto w-auto object-contain opacity-5 md:block"
      />
      {/* Container principal — overflow-visible garante que sticky "veja" a viewport */}
      <div className="mx-auto max-w-7xl overflow-visible px-6">
        {/* Grid — keep it plain (no motion wrapper aqui) */}
        <div className="grid items-start overflow-visible lg:grid-cols-[400px_1fr] lg:gap-16">
          {/* ASIDE (sticky) — isolado, sem transform/animation nos ancestrais */}
          <aside className="self-start md:sticky md:top-28">
            <HeaderSection
              title="Perguntas frequentes"
              description="Tire suas dúvidas sobre nossos serviços"
              direction="left"
            />
          </aside>

          {/* Conteúdo da direita — as animações ficam apenas aqui */}
          <div className="relative order-1 lg:order-2">
            {/* animação aplicada apenas ao conteúdo interno (não ao wrapper do grid) */}
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="w-full"
              // IMPORTANTE: impede que framer-motion mantenha transform no wrapper do sticky
              style={{ transform: "none" }}
            >
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 }}
                className="mx-auto max-w-4xl"
              >
                <Accordion type="single" collapsible className="space-y-2">
                  {faq.map((item, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, x: -20 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.45, delay: index * 0.05 }}
                    >
                      <AccordionItem
                        value={`item-${index}`}
                        className="rounded-none border-none bg-transparent shadow-none"
                      >
                        <AccordionTrigger className="cursor-pointer border-b border-red-500 py-4 text-left shadow-none">
                          <span className="text-foreground flex w-full items-center justify-between font-medium md:text-lg">
                            {item.question}
                          </span>
                        </AccordionTrigger>
                        <AccordionContent className="py-4">
                          <p className="text-muted-foreground leading-relaxed tracking-wide">
                            {item.answer}
                          </p>
                        </AccordionContent>
                      </AccordionItem>
                    </motion.div>
                  ))}
                </Accordion>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
